import React, { createContext, type PropsWithChildren, useContext } from 'react';

import { type ActivityItem } from '@atlassian/recent-work-client';

export type RecentActivityItem = ActivityItem | null;

export const RecentActivityItemContext: React.Context<RecentActivityItem> =
	createContext<RecentActivityItem>(null);

type RecentActivityItemProviderProps = PropsWithChildren<{
	item: RecentActivityItem;
}>;

export const RecentActivityItemProvider = ({
	children,
	item,
}: RecentActivityItemProviderProps): React.JSX.Element => {
	return (
		<RecentActivityItemContext.Provider value={item}>{children}</RecentActivityItemContext.Provider>
	);
};

export const useRecentActivityItem = (): RecentActivityItem =>
	useContext<RecentActivityItem>(RecentActivityItemContext);
